import { useState } from "react";
import ChrOffCanvas from "../../../components/generic/PageUI/Basic/ChrOffCanvas/index";

const useChrOffCanvas = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openedAtleastOnce, setOpenedAtleastOnce] = useState(false);

  const openHandler = (_event) => {
    setIsOpen(true);
    if (!openedAtleastOnce) setOpenedAtleastOnce(true);
  }

  const closeHandler = (_event) => {
    setIsOpen(false);
  }

  return { OffCanvasComponent: ChrOffCanvas, offCanvasActions: { openHandler, closeHandler }, offCanvasOptions: { isOpen, openedAtleastOnce } }
}

export default useChrOffCanvas;